module.exports = __webpack_public_path__ + "assets/img/23_22.c3059b19.jpg";